import React, { useState } from 'react';
import axios from 'axios';
import instance from '../api/axios/utils.ts/instance';
import { UserType } from '../enum';
import { ApiResponse, User } from '../constants/types';
import { useCsInfo } from '../hooks/useCsInfo';

export default function Maintenance() {
  const [checking, setChecking] = useState(false);
  const [checkFailed, setCheckFailed] = useState(false);
  // 점검 중에는 설정 조회도 실패할 수 있어 폴백 연락처가 노출된다
  const { phone: contactPhone } = useCsInfo();

  const handleRetry = async () => {
    setChecking(true);
    setCheckFailed(false);

    try {
      // 서버 상태 확인 (간단한 GET 요청)
      await axios.get(
        `${process.env.REACT_APP_JEBS_API_URL}/v1/public/banners`,
        {
          timeout: 10000,
        },
      );

      // 서버 정상 → 사용자 정보 확인
      try {
        const userResponse = await instance.get<ApiResponse<User>>(
          '/v1/auth/user-authorization',
        );
        if (
          userResponse.data.statusCode === 200 &&
          userResponse.data.data?.type === UserType.STUDENT
        ) {
          // 학생이면 /student/class로 이동
          window.location.href = '/student/class';
          return;
        }
      } catch {
        // 사용자 정보를 가져올 수 없어도 계속 진행
      }

      // 학생이 아니거나 사용자 정보를 가져올 수 없으면 홈으로 이동
      window.location.href = '/';
    } catch {
      // 아직 서버 불안정
      setCheckFailed(true);
    } finally {
      setChecking(false);
    }
  };

  return (
    <div className="bg-gray-50">
      <div className="flex min-h-screen flex-col items-center px-4 pt-10 sm:justify-center sm:pt-0">
        <img
          src="/images/common/logo.svg"
          alt="젭스 로고"
          className="mb-8 h-10"
        />

        <div className="mb-6 text-7xl">🔧</div>

        <h1 className="mb-3 text-center text-2xl font-bold text-gray-900">
          서비스 점검 중입니다
        </h1>

        <p className="mb-2 max-w-md text-center text-base text-gray-600">
          더 나은 서비스를 위해 <br />
          시스템 점검을 진행하고 있습니다.
        </p>
        <p className="mb-8 max-w-md text-center text-base text-gray-600">
          잠시 후 다시 이용해 주세요.
        </p>

        <button
          onClick={handleRetry}
          disabled={checking}
          className="rounded-lg bg-purple5 px-8 py-3 text-base font-semibold text-white transition-colors hover:bg-purple6 disabled:opacity-50"
        >
          {checking ? '확인 중...' : '다시 시도'}
        </button>

        {checkFailed && (
          <p className="mt-4 text-sm text-red5">
            아직 서버가 복구되지 않았습니다. 잠시 후 다시 시도해 주세요.
          </p>
        )}

        <p className="mt-6 text-center text-sm text-gray-500">
          문제가 지속되면 고객센터로 문의해 주세요.
          <br />
          {contactPhone}
        </p>
      </div>
    </div>
  );
}
